import '@formatjs/intl-listformat/polyfill';
import '@formatjs/intl-listformat/locale-data/en';

export function formatFeature(feature: string[]) {
    const featureOptions: { [key: string]: string } = {
        has_garden: 'garden',
        has_balcony_terrace: 'balcony/terrace',
        has_parking_garage: 'parking/garage'
    };

    if (!feature.length) {
        return '';
    }

    const features = feature.map((option) => featureOptions[option]);

    const formatter = new Intl.ListFormat('en-GB', {
        style: 'long',
        type: 'conjunction'
    });

    return `Must-have ${formatter.format(features)}`;
}
